import ApiBuilder, { registerNewVenuePayload, updateVenuePayload, UpdateVendorSportAndCourtOnEditPayload } from "@/api/ApiBuilder";
import { Values } from "@/constants/Values";
import { Court, CreateWebsiteType,UpdateturfImagesType, DeleteImagesType, GetSlotsByDatePayload ,UpdateVendorVenueSlotsPayloadType, ToggalBookingType, CreateVendorDiscountType} from "@/types/interfaceType";
import { createAsyncThunk, isRejectedWithValue } from "@reduxjs/toolkit";



interface getdefaultArgs {
    queryParams?:{
        page:number,limit:number,status:string
    };
    data?:any;
    pathparams?: String;
    token?: string;
    callback?: (response: any) => void; // Optional callback
}

interface getBoookingArgs {
    queryParams?:{
        page:number,limit:number,status:string,
        bookingId?:string, refId?:string, date?:string,
        /** VENDOR | MARKETPLACE | DBL — omit for every source. */
        bookingSource?:string
    };
    page?:number;
    pathparams?: String;
    callback?: (response: any) => void; // Optional callback
}

interface getDicountArgs {
    queryParams?:{
        page:number,
        limit:number,
        status:string,
    };
    page?:number;
    pathparams?: String;
    callback?: (response: any) => void; // Optional callback
}

interface CreateDicountArgs {
    payload:CreateVendorDiscountType,
    callback?: (response: any) => void; // Optional callback
}


interface registerNewVenuePayloadArg {
    payload: registerNewVenuePayload; // Replace `any` with a proper interface if available
    callback?: (response: any) => void; // Optional callback
}

interface GetSlotsByDateArg {
    payload: GetSlotsByDatePayload; // Replace `any` with a proper interface if available
    callback?: (response: any) => void; // Optional callback
}


interface ToggalBookingPaylaod{
    pathparams?: String;
    payload: ToggalBookingType; // Replace `any` with a proper interface if available
    callback?: (response: any) => void; // Optional callback

}

interface ToggalDiscountPaylaod{
    pathparams?: String;
    callback?: (response: any) => void; // Optional callback

}

interface CreateWebsitePaylaod{
    payload: CreateWebsiteType; // Replace `any` with a proper interface if available
    callback?: (response: any) => void; // Optional callback

}


interface updateturfImagesArgs {
    payload: FormData; // Replace `any` with a proper interface if available
    callback?: (response: any) => void; // Optional callback
}

interface addNewCourtArg {
    payload: {
        venueId: string,
        sportId: string,
        courtData: Court
    }; // Replace `any` with a proper interface if available
    callback?: (response: any) => void; // Optional callback
}

interface DeleteImagesArgs {
    payload: DeleteImagesType,
    callback?: (response: any) => void; // Optional callback
}


interface updateVenuePayloadArg {
    payload: updateVenuePayload; // Replace `any` with a proper interface if available
    venueId: String,
    callback?: (response: any) => void; // Optional callback
}
interface deleteSportByIdArg{
    venueId: String,
    payload:{ sportId: String}
    callback?: (response: any) => void; // Optional callback
}


interface UpdateVendorSportAndCourtOnEditArg {
    payload: UpdateVendorSportAndCourtOnEditPayload; // Replace `any` with a proper interface if available
    callback?: (response: any) => void; // Optional callback
}
interface updateVendorVenueSlotsArg{
    payload: UpdateVendorVenueSlotsPayloadType; // Replace `any` with a proper interface if available
    callback?: (response: any) => void; // Optional callback
}


export const registerNewVenue = createAsyncThunk<any, registerNewVenuePayloadArg>(
    "venue/registerNewVenue",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.registerNewVenue(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Venue registration failed";

            return rejectWithValue(errorMessage);
        }
    }
);

export const venueUpdateById = createAsyncThunk<any, updateVenuePayloadArg>(
    "update/venue/venueUpdateById",
    async ({ payload, venueId, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.venueUpdateById(payload, venueId);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Venue registration failed";

            return rejectWithValue(errorMessage);
        }
    }
);

export const deleteSportById = createAsyncThunk<any, deleteSportByIdArg>(
    "venue/delete/deleteSportById",
    async ({ payload, venueId, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.deleteSportById(payload, venueId);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Venue registration failed";

            return rejectWithValue(errorMessage);
        }
    }
);

export const getPendingVenueDetails = createAsyncThunk<any, getdefaultArgs>(
    "venue/getPendingVenueDetails",
    async ({ callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getPendingVenueDetails();
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Venues fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);


export const getCompletedVenueDetails = createAsyncThunk<any, getdefaultArgs>(
    "venue/getCompletedVenueDetails",
    async ({ callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getCompletedVenueDetails();
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Venues fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);

export const getVendorVenueDetailsById = createAsyncThunk<any, getdefaultArgs>(
    "venue/getVendorVenueDetailsById",
    async ({ pathparams, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getVendorVenueDetailsById(pathparams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Venues fetch failed";
            if (callback) {
                callback(error)
            }
            return rejectWithValue(errorMessage);
        }
    }
);


export const updateVendorSportAndCourtOnEdit = createAsyncThunk<any, UpdateVendorSportAndCourtOnEditArg>(
    "venue/updateVendorSportAndCourtOnEdit",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.updateVendorSportAndCourtOnEdit(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Venues fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);

export const addNewCourtInVendorSports = createAsyncThunk<any, addNewCourtArg>(
    "venue/addNewCourtInVendorSports",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.addNewCourtInVendorSports(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Venues fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);


export const updateturfImages = createAsyncThunk<any, updateturfImagesArgs>(
    "venue/updateturfImages",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.updateturfImages(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Venues image upload failed";

            return rejectWithValue(errorMessage);
        }
    }
);


export const deleteImages = createAsyncThunk<any, DeleteImagesArgs>(
    "venue/deleteImages",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.deleteImages(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Static config fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);

export const getSlotsByDate = createAsyncThunk<any, GetSlotsByDateArg>(
    "venue/getSlotsByDate",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getSlotsByDate(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Slots fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);

export const updateVendorVenueSlots = createAsyncThunk<any, updateVendorVenueSlotsArg>(
    "venue/updateVendorVenueSlots",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.updateVendorVenueSlots(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Slots fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);


export const getStaticConfig = createAsyncThunk<any, getdefaultArgs>(
    "venue/static/getStaticConfig",
    async ({ pathparams, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getStaticConfig(pathparams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Static config fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);


export const toggleBookingByVenueId = createAsyncThunk<any, ToggalBookingPaylaod>(
    "vendor/toggleBookingByVenueId",
    async ({ pathparams,payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.toggleBookingByVenueId(pathparams,payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Booking toggal failed";

            return rejectWithValue(errorMessage);
        }
    }
);




export const createwebsite = createAsyncThunk<any, CreateWebsitePaylaod>(
    "vendor/createwebsite",
    async ({ payload, callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.createwebsite(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Website creation failed";

            return rejectWithValue(errorMessage);
        }
    }
);


export const getWebsiteByVendor = createAsyncThunk<any, getdefaultArgs>(
    "vendor/getWebsiteByVendor",
    async ({ callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getWebsiteByVendor();
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Website details fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);

export const getVendorPromotions = createAsyncThunk<any, getdefaultArgs>(
    "vendor/getVendorPromotions",
    async ({ callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getVendorPromotions();
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Promotions fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);


export const getVendorsBookingsWithPagination = createAsyncThunk<any, getBoookingArgs>(
    "vendor/getVendorsBookingsWithPagination",
    async ({ queryParams,page,callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getVendorsBookingsWithPagination(queryParams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Booking fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);

export const getVendorsBookingsDetailsWithID = createAsyncThunk<any, getBoookingArgs>(
    "vendor/getVendorsBookingsDetailsWithID",
    async ({ pathparams,page,callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getVendorsBookingsDetailsWithID(pathparams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Booking fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);



export const getVendorDiscounts = createAsyncThunk<any, getDicountArgs>(
    "vendor/getVendorDiscounts",
    async ({ queryParams,page,callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.getVendorDiscounts(queryParams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Discount fetch failed";

            return rejectWithValue(errorMessage);
        }
    }
);



export const createVendorDiscount = createAsyncThunk<any, CreateDicountArgs>(
    "vendor/createVendorDiscount",
    async ({ payload,callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.createVendorDiscount(payload);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Create Discount failed";

            return rejectWithValue(errorMessage);
        }
    }
);


export const toggleVendorDiscount = createAsyncThunk<any, ToggalDiscountPaylaod>(
    "vendor/toggleVendorDiscount",
    async ({ pathparams,callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.toggleVendorDiscount(pathparams);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Toggle Discount failed";

            return rejectWithValue(errorMessage);
        }
    }
);


export const checkAgreementStatus = createAsyncThunk<any, getdefaultArgs>(
    "vendor/checkAgreementStatus",
    async ({ data,callback }, { rejectWithValue }) => {
        try {
            const response = await ApiBuilder.checkAgreementStatus(data);
            if (callback) {
                callback(response)
            }
            return response;
        } catch (error) {
            const errorMessage =
                error?.error || error?.response?.data?.message || error?.message || "Something went wrong";

            return rejectWithValue(errorMessage);
        }
    }
);






// export const updateVendorProfile = createAsyncThunk<any, updateVendorProfileArg>(
//     "profile/updateVendorProfile",
//     async ({ payload, callback }, { rejectWithValue }) => {
//         try {
//             const response = await ApiBuilder.updateVendorProfile(payload);
//             if (callback) {
//                 callback(response)
//             }
//             return response;
//         } catch (error) {
//             const errorMessage =
//                 error?.error || error?.response?.data?.message || error?.message || "Update Vendor Profile Failed";

//             return rejectWithValue(errorMessage);
//         }
//     }
// );

